import React from 'react';
import { GoogleLogin, GoogleOAuthProvider } from '@react-oauth/google';

const clientId = 'Client_ID';

const GoogleAuth = () => {
  const onSuccess = (credentialResponse) => {
    console.log('Login Success:', credentialResponse.accessToken);
  };

  const onFailure = (error) => {
    console.error('Login Failure:', error);
  };

  return (
    <div className='mt-5 pt-5'>
      <div className='row'>
        <div className='col-4 m-auto'>
          <GoogleOAuthProvider clientId={clientId}>
            <GoogleLogin
              onSuccess={onSuccess}
              onError={onFailure}
            />
          </GoogleOAuthProvider>
        </div>
      </div>
    </div>
  );
};

export default GoogleAuth;
